<style scoped>
    .main {
        --viewfinder-height: 80px;
        --coarse-adjust-height: 40px;
        background-color: var(--background-color, var(--ion-background-color));
        width: 100%;
        flex-grow: 1;
        position: relative;
        height: calc(var(--viewfinder-height) + var(--coarse-adjust-height));
        transition: height 400ms ease-in-out;
    }

    .main.shrunk {
        height: var(--viewfinder-height);
    }

    .vf-canvas {
        background-color: var(--background-color, var(--ion-background-color));
    }

    .vf-holder {
        position: absolute;
        height: var(--viewfinder-height);
        min-height: var(--viewfinder-height);
        max-height: var(--viewfinder-height);
        bottom: 0;
        left: 0;
        right: 0;
    }

    .vf-holder.shrunk {
        height: 0;
    }

    .overlay-canvas {
        z-index: 1;
        background-color: transparent;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
    }
</style>

<div #main class="main" [class.shrunk]="shrunk">
    <div class="vf-holder">
        <canvas #vfCanvas class="vf-canvas"></canvas>
    </div>
    <canvas
        #overlayCanvas
        class="overlay-canvas"
        (mousedown)="onMousedown($event)"
        (touchstart)="onTouchstart($event)"
        (touchmove)="onTouchmove($event)"
        (touchend)="onTouchend($event)"
    ></canvas>
</div>
